module.exports = __webpack_public_path__ + "img/jew.d2cf28a7.png";